<template>
	<div v-bottom="nextPage" class="run">
		<div v-for="(item,index) in runRecords" :key="index">
			<p class="head flex between">
				<span>{{item.dateAndWeek}}</span>
				<span>
					运动次数:
					<span>{{item.logs?.length}}次</span>
				</span>
			</p>
			<SportCard v-for="(recordItem,recordIndex) in item.logs" :key="recordIndex" :sportInfo="recordItem" />
		</div>
		<!-- <div v-if="endPage" class="scroll-end"></div> -->
		<DetailsModal ref="details" />
	</div>
</template>

<script>
import SportCard from "./sportCard.vue";
import DetailsModal from "./details.vue";
import { getWeek,secondsToString } from "@/utils/date.js";
function queryParams() {
	return {
		teamId: undefined,
		pageNo: 1,
		pageSize: 10,
	};
}
export default {
	components: {
		DetailsModal,
		SportCard
	},
	props: {
		currentTab: {},
	},
	data() {
		return {
			params: {
				teamId: undefined,
				// pageNo: 1,
				// pageSize: 10,
			},
			pages: 0,
			runRecords: [],
		};
	},
	watch: {
		currentTab: {
			handler(newVal) {
				if (newVal === 0) {
					this.params = queryParams();
					this.getRunRecords();
				}
			},
			immediate: true,
		},
	},
	// computed: {
	// 	endPage() {
	// 		return this.pages && this.pages == this.params.pageNo;
	// 	},
	// },
	methods: {
		nextPage() {
			// if (this.endPage) return;
			// this.params.pageNo++;
			// this.getRunRecords();
		},
		async getRunRecords() {
			console.log("getRunRecords");
			this.params.teamId = this.$route.query.gradeId;
			try {
				const {success,message,result} = await this.$http.get(`h5/homePage/runningLog`,{params:this.params});
				if (!success) throw new Error(message);
				let arr = result.logs;
				arr.forEach((item) => {
					item.dateAndWeek =
						item.motionTime.split(" ")[0] +
						" " +
						getWeek(item.motionTime);
				});
				this.runRecords = arr;
			} catch (error) {
				console.log("getRunRecords", error);
			}
		},
	},
};
</script>

<style scoped lang="less">
.run {
	height: 100%;
	padding: 10 / @rem 17 / @rem;
	background-color: rgba(255, 162, 22, 0.6);
	overflow-y: auto;

	.card {
		padding: 12 / @rem 15 / @rem;
		margin-bottom: 11 / @rem;
		background: #ffffff;
		box-shadow: 0 3 / @rem 17 / @rem 0 rgba(143, 72, 0, 0.2);
		border-radius: 12 / @rem;
	}
	p.head {
		padding: 12 / @rem 0 12 / @rem;
		font-size: 10 / @rem;
		color: white;
		span span {
			font-size: 12 / @rem;
		}
	}

	.info-l {
		padding-bottom: 12 / @rem;
		border-bottom: 1 / @rem solid rgba(31, 30, 29, 0.1);
		> div {
			flex: 1;
			height: 61 / @rem;
			align-items: flex-start;
			color: rgba(31, 30, 29, 0.3);
			p {
				letter-spacing: 1 / @rem;
				span {
					font-size: 19 / @rem;
					font-weight: bold;
					color: rgba(31, 30, 29, 1);
				}
			}
		}
		> span {
			display: flex;
			width: 61 / @rem;
			height: 61 / @rem;
			border-radius: 50%;
			font-size: 19 / @rem;
			&.success {
				color: rgba(46, 204, 73, 1);
				border: 2 / @rem solid rgba(46, 204, 73, 1);
			}
			&.err {
				color: rgba(242, 65, 19, 1);
				border: 2 / @rem solid rgba(242, 65, 19, 1);
			}
		}
	}

	button {
		width: 88 / @rem;
		height: 28 / @rem;
		margin-top: 13 / @rem;
		border-radius: 15 / @rem;
		color: white;
		font-size: 10 / @rem;
		letter-spacing: 1 / @rem;
		background-color: rgba(254, 198, 51, 1);
	}
}
</style>
